"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var MessagePreviewFull_1 = require("./components/MessagePreviewFull");
var discardMessagePreviewOption_1 = require("./actions/discardMessagePreviewOption");
var saveMessagePreviewOption_1 = require("./actions/saveMessagePreviewOption");
var isMessagePreviewOptionDirty_1 = require("./utils/isMessagePreviewOptionDirty");
var isMessagePreviewEnabled_1 = require("./utils/isMessagePreviewEnabled");
var MessagePreviewOption = {
    key: 'messagePreview',
    titleStringKey: 'optionTitle_messagePreview',
    searchTermsStringKey: 'optionTitle_messagePreview',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MessagePreviewFull_1.default, null); },
        isDirty: isMessagePreviewOptionDirty_1.default,
        onSave: saveMessagePreviewOption_1.default,
        onDiscard: discardMessagePreviewOption_1.default,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: isMessagePreviewEnabled_1.default,
            onToggle: saveMessagePreviewOption_1.onMessagePreviewToggle,
        },
        order: 7 /* PreviewText */,
        workloads: 1 /* Mail */,
    },
};
exports.default = MessagePreviewOption;
//# sourceMappingURL=MessagePreviewOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-preview-option/lib/MessagePreviewOption.js
// module id = 5106
// module chunks = 2